'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _components2 = require('components');

require('./CartProduct.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    CartProductView: {
        displayName: 'CartProductView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/CartProduct/default/CartProductView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var CartProductView = _wrapComponent('CartProductView')(function (_Component) {
    (0, _inherits3.default)(CartProductView, _Component);

    function CartProductView(props) {
        (0, _classCallCheck3.default)(this, CartProductView);

        // вызовем родительский конструктор, чтобы ничего не сломалось
        var _this = (0, _possibleConstructorReturn3.default)(this, (CartProductView.__proto__ || (0, _getPrototypeOf2.default)(CartProductView)).call(this, props));

        _this.handleClickOnVideo = function () {
            _this.setState({
                full_screen_mode: true,
                video_mode: true,
                start_index_preview: 0
            });
        };

        _this.handleClickOnActiveSlide = function () {
            _this.setState({ // если режим включен - выключаем его, иначе - включаем
                full_screen_mode: !_this.state.full_screen_mode,
                video_mode: false,
                start_index_preview: 0
            });
        };

        _this.handleChangeSlide = function (prop) {
            _this.setState({
                video_mode: false,
                active_slide: prop
            });
        };

        _this.clickOnActiveSlide = function () {
            var clickOnActive = _this.props.clickOnActive;

            clickOnActive();
        };

        _this.clickOnPrev = function (countPreview) {
            var active_index = void 0;

            // узнаем индекс активного слайда
            for (var i = 0; i <= _this.props.product_detail.pictures.length; ++i) {
                if (_this.props.product_detail.pictures[i].id == _this.state.active_slide) {
                    active_index = i;
                    break;
                }
            }

            // если слайд не первый
            if (active_index != 0) {
                _this.setState({
                    active_slide: _this.props.product_detail.pictures[active_index - 1].id
                });
            } else {
                _this.setState({
                    active_slide: _this.props.product_detail.pictures[_this.props.product_detail.pictures.length - 1].id,
                    start_index_preview: _this.props.product_detail.pictures.length - countPreview
                });
            }

            if (active_index < _this.props.product_detail.pictures.length - 2) {
                _this.clickOnPrevPreview();
            }
        };

        _this.clickOnNext = function (countPreview) {
            var active_index = void 0;

            // узнаем индекс активного слайда
            for (var i = 0; i <= _this.props.product_detail.pictures.length; ++i) {
                if (_this.props.product_detail.pictures[i].id == _this.state.active_slide) {
                    active_index = i;
                    break;
                }
            }

            // если слайд не последний
            if (active_index != _this.props.product_detail.pictures.length - 1) {
                _this.setState({
                    active_slide: _this.props.product_detail.pictures[active_index + 1].id
                });
            } else {
                _this.setState({
                    active_slide: _this.props.product_detail.pictures[0].id,
                    start_index_preview: 0
                });
            }

            if (active_index > 1) {
                _this.clickOnNextPreview(countPreview);
            }
        };

        _this.clickOnPrevPreview = function () {
            if (_this.state.start_index_preview - 1 >= 0) {
                _this.setState({
                    start_index_preview: _this.state.start_index_preview - 1
                });
            }
        };

        _this.clickOnNextPreview = function (count) {
            var start_index_preview = _this.state.start_index_preview;

            var length = _this.props.product_detail.pictures.length;
            if (start_index_preview < length - count) {
                _this.setState({
                    start_index_preview: _this.state.start_index_preview + 1
                });
            }
        };

        if (!_this.props.product_detail.pictures) {
            _this.props.product_detail.pictures = [];
        }

        _this.state = {
            active_slide: _this.props.product_detail.pictures[0] ? _this.props.product_detail.pictures[0].id : 0, // ставим активным первую фото в массиве pictures
            video_mode: false, //режим просмотра видео
            full_screen_mode: false, // полноэкранный режим слайдера
            start_index_preview: 0
        };
        return _this;
    }

    (0, _createClass3.default)(CartProductView, [{
        key: 'render',
        value: function render() {
            var product_detail = this.props.product_detail;


            var slider = _react3.default.createElement(_components2.Slider, {
                active_slide: this.state.active_slide,
                video_mode: this.state.video_mode,
                full_screen_mode: this.state.full_screen_mode,
                start_index_preview: this.state.start_index_preview,
                product_detail: product_detail,
                clickOnActive: this.handleClickOnActiveSlide,
                onAddToBasket: this.props.addProduct,
                handleChangeSlide: this.handleChangeSlide,
                clickOnActiveSlide: this.clickOnActiveSlide,
                clickOnVideo: this.handleClickOnVideo,
                clickOnPrev: this.clickOnPrev,
                clickOnNext: this.clickOnNext,
                clickOnPrevPreview: this.clickOnPrevPreview,
                clickOnNextPreview: this.clickOnNextPreview
            });
            if (this.state.full_screen_mode) {
                // если полноэкранный режим слайдера включен
                return _react3.default.createElement(
                    _reactBootstrap.Modal,
                    {
                        show: this.state.full_screen_mode,
                        dialogClassName: 'slider-modal' },
                    _react3.default.createElement(
                        _reactBootstrap.Modal.Header,
                        null,
                        _react3.default.createElement(
                            _reactBootstrap.Modal.Title,
                            null,
                            _react3.default.createElement(
                                'div',
                                { className: 'container' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'no-margin col-xs-12 col-sm-7 body-holder', id: 'active' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'body', id: 'active' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'title' },
                                            _react3.default.createElement(
                                                'a',
                                                {
                                                    href: product_detail.url },
                                                product_detail.name
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.Modal.Body,
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { id: 'single-product' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'container' },
                                    slider
                                )
                            )
                        )
                    )
                );
            } else {
                // если полноэкранный режим слайдера выключен
                return _react3.default.createElement(
                    'div',
                    { className: 'col-md-12', style: { borderRadius: '7px' } },
                    _react3.default.createElement(
                        'div',
                        { id: 'single-product', className: 'flying-to-cart-holder' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            slider,
                            _react3.default.createElement(_components2.ShortDescription, { product_detail: product_detail })
                        )
                    )
                );
            }
        }

        /**
         * Обработчик открытия слайдера в режиме видео
         */


        /**
         * Обработчик раскрытия слайдера на весь экран
         */


        /**
         * Обработчик изменения активного слайда
         * @param prop
         */


        /**
         * Обработчик раскрытия слайдера по нажатию на активное фото
         */


        /**
         * Обработчик нажатия на кнопку "Назад" у активного фото
         */


        /**
         * Обработчик нажатия на кнопку "Далее" у активного фото
         */


        /**
         * Обработчик нажатия на кнопку "Назад" у ряда превьюх
         */


        /**
         * Обработчик нажатия на кнопку "Далее" у ряда превьюх
         */

    }]);
    return CartProductView;
}(_react2.Component));

exports.default = CartProductView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/CartProduct/default/CartProductView.jsx
// module id = 1804
// module chunks = 0